import { render } from "./navibar.vue?vue&type=template&id=58786bae&scoped=true"
import script from "./navibar.vue?vue&type=script&lang=js"
export * from "./navibar.vue?vue&type=script&lang=js"

import "./navibar.vue?vue&type=style&index=0&id=58786bae&scoped=true&lang=scss"

import exportComponent from "D:\\SelfCode\\ktpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58786bae"]])

export default __exports__